var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMapZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 6.37506H12.9836C13.1534 6.37287 13.3183 6.43175 13.4483 6.54096C13.5783 6.65017 13.6648 6.80245 13.6919 6.97006L14.8749 14.0534C14.8914 14.1554 14.8854 14.2599 14.8573 14.3594C14.8292 14.4589 14.7797 14.551 14.7122 14.6293C14.6447 14.7076 14.5608 14.7702 14.4666 14.8126C14.3723 14.8551 14.2699 14.8764 14.1665 14.8751H2.83319C2.72982 14.8764 2.62741 14.8551 2.53314 14.8126C2.43888 14.7702 2.35506 14.7076 2.28756 14.6293C2.22006 14.551 2.17051 14.4589 2.1424 14.3594C2.1143 14.2599 2.10831 14.1554 2.12486 14.0534L3.30777 6.97006C3.33493 6.80245 3.42138 6.65017 3.5514 6.54096C3.68141 6.43175 3.84633 6.37287 4.01611 6.37506H5.66652",
    stroke: "#E92127",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 4.95833C11.3332 4.20689 11.0347 3.48622 10.5033 2.95486C9.97195 2.42351 9.25128 2.125 8.49984 2.125C7.74839 2.125 7.02772 2.42351 6.49637 2.95486C5.96501 3.48622 5.6665 4.20689 5.6665 4.95833C5.6665 7.79167 8.49984 10.625 8.49984 10.625C8.49984 10.625 11.3332 7.79167 11.3332 4.95833Z",
    stroke: "#E92127",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapZone);
export default __webpack_public_path__ + "static/media/icon_map_zone.7cc0aff51da88b54b468dabf1c03afdf.svg";
export { ForwardRef as ReactComponent };